var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 258.9 252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5373b7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laag_1-2",
    "data-name": "Laag 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.39,40a22.69,22.69,0,1,0,22.69,22.69A22.69,22.69,0,0,0,90.39,40M242.62,0Q230.1,0,226.75,10.85L150,229.26,104.47,117.4a15.69,15.69,0,0,0-5.22-7.72Q95.7,107,89.85,107,78.59,107,74,117.4L30.11,230.88,12.64,180.49Q11,174.65,6.8,172.14A17.26,17.26,0,0,0,0,169.78v73.65L3.13,252H53.44L88.2,156.88,126.25,252h50.49L257.65,23.79a7,7,0,0,0,1-3.13,31.91,31.91,0,0,0,.21-3.55c0-5.28-1.61-9.45-4.8-12.52A16,16,0,0,0,242.62,0"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo_1.f115d78b53f3f3f28ea9f28f7f867699.svg";
export { ForwardRef as ReactComponent };